import React, { useContext, useEffect, useMemo } from "react";
import "./tasks.page.scoped.scss";
import { CommonService } from "../../services/common/common.service";
import { useTranslation } from "react-i18next";
import HeaderComponent from "../../components/header/header.component";
import { TasksProvider } from "../../store/providers/tasks.provider";
import { GlobalContext } from "../../store";
import TasksContent from "../../modules/tasks/components/tasks-content/tasks-content.component";
import { ContentLayout } from "../../layouts/content/content.layout";
import PagesHeadComponent from "../../components/pages-head-component/pages-head.component";

export default function TasksPage() {
  const commonService = useMemo(() => new CommonService(), []);
  const { t } = useTranslation();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    const title = t("PAGE_META_TITLES.AI_TASKS");
    commonService.setTitle(title);
    setPageTitle(title);
  }, [t, setPageTitle, commonService]);

  return (
    <TasksProvider>
      <HeaderComponent />
      <ContentLayout>
        <PagesHeadComponent
          title={t("PAGES_HEAD.AI_TASKS_TITLE")}
          subTitle={t("PAGES_HEAD.AI_TASKS_SUB_TITLE")}
        />
        <TasksContent />
      </ContentLayout>
    </TasksProvider>
  );
}
